
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_5a145_19o6d_9",
  "inline-container": "awsui_inline-container_5a145_19o6d_13",
  "inline-container-trigger": "awsui_inline-container-trigger_5a145_19o6d_16",
  "inline-trigger": "awsui_inline-trigger_5a145_19o6d_20"
};
  